module.exports = __webpack_public_path__ + "winner-photo.jpg?bf1b690f5354ad2367bd4ce4c45ee00e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/winner-photo.jpg
// module id = 155
// module chunks = 0